// ============================================
// ZENTRALE AFFILIATE-PRODUKT-VERWALTUNG
// ============================================
// Hier können Sie alle Affiliate-Links an einem Ort pflegen.
// Ersetzen Sie einfach die "#" durch Ihre echten Affiliate-Links.

export interface AffiliateProduct {
  id: string;
  name: string;
  image: string;
  reason: string;
  suitableFor: string[];
  amazonLink: string;
  zooplusLink: string;
}

// ============================================
// HYGIENE & INKONTINENZ PRODUKTE
// ============================================
export const hygieneProducts: AffiliateProduct[] = [
  {
    id: 'hygiene-001',
    name: 'Waschbare Inkontinenz-Unterlagen',
    image: 'https://public.readdy.ai/ai/img_res/17e30165a71cf1997a3e9eed60ac6cf0.jpg',
    reason: 'Waschbare Unterlagen sind umweltfreundlich, kostengünstig auf lange Sicht und bieten zuverlässigen Schutz für Böden und Liegeflächen.',
    suitableFor: ['Nächtliche Inkontinenz', 'Liegeplätze schützen', 'Hygienisch'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B0067ZMLPE',
    zooplusLink: '#',
  },
  {
    id: 'hygiene-002',
    name: 'Enzymatische Geruchsentferner',
    image: 'https://readdy.ai/api/search-image?query=enzymatic%20pet%20odor%20remover%20spray%20bottle%20product%20photography%20clean%20simple%20background%20professional%20lighting%20showing%20effective%20cleaning%20solution&width=400&height=400&seq=prod-hygiene-002&orientation=squarish',
    reason: 'Enzymatische Reiniger zersetzen Uringeruch auf molekularer Ebene, statt ihn nur zu überdecken. Das verhindert, dass der Hund dieselbe Stelle erneut markiert.',
    suitableFor: ['Geruchsneutralisation', 'Fleckenentfernung', 'Dermatologisch getestet'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B07D9W47J4',
    zooplusLink: '#',
  },
  {
    id: 'hygiene-003',
    name: 'Hygienehosen für Hunde',
    image: 'https://readdy.ai/api/search-image?query=senior%20golden%20retriever%20dog%20wearing%20black%20fabric%20diaper%20pants%20covering%20rear%20end%20and%20hindquarters%20from%20behind%20view%20showing%20protective%20hygiene%20underwear%20wrapped%20around%20back%20legs%20and%20tail%20area%20like%20incontinence%20briefs%20product%20photo%20on%20white%20background&width=400&height=400&seq=prod-hygiene-003-v5&orientation=squarish',
    reason: 'Hygienehosen bieten Schutz bei leichter bis mittlerer Inkontinenz und ermöglichen dem Hund mehr Bewegungsfreiheit im Haus.',
    suitableFor: ['Leichte bis mittlere Inkontinenz', 'Mobilität erhalten', 'Würdevolle Lösung für den Alltag'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B00RCPLQXQ',
    zooplusLink: '#',
  },
];

// ============================================
// MOBILITÄT & AUFSTEHEN PRODUKTE
// ============================================
export const mobilityProducts: AffiliateProduct[] = [
  {
    id: 'mobility-001',
    name: 'Tragehilfe mit Griff',
    image: 'https://readdy.ai/api/search-image?query=senior%20golden%20retriever%20dog%20wearing%20supportive%20lifting%20harness%20with%20handle%20on%20back%20elderly%20dog%20mobility%20aid%20product%20photography%20neutral%20clean%20background%20showing%20ergonomic%20design%20comfortable%20padded%20straps%20gray%20muzzle%20aged%20appearance&width=400&height=400&seq=prod-mobility-001-v2&orientation=squarish',
    reason: 'Tragehilfen mit Griff unterstützen Ihren Hund beim Aufstehen und Treppensteigen, ohne seinen Körper zu belasten.',
    suitableFor: ['Aufstehhilfe', 'Treppensteigen', 'Spaziergänge unterstützen'],
    amazonLink: 'https://www.amazon.de/OneTigris-Hundegeschirr-Unterst%C3%BCtzung-Sicherheitsgeschirr-Schultergurte/dp/B0C77LMM27/ref=sr_1_6?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=2HTJS5IEPJH2X&dib=eyJ2IjoiMSJ9.9i8B836COFoOHbNyo0KRNeIMi_Z31KxQ-EfQIIhwBvDwCjnOAJdqesul1TrdxkCbmJVERXvbN8gA8FgDo5NPm5QBoJDJ1DxyOzs3bLmr9FCNx7nPuG6BHsSu1Iv2MBlsdSy8RUlxYlOoRiwr2ynQ5bkeU_PkPNrKJbowQSix26KwwrXVd_FK_Q-dhnnIk0r9eiYhQkharOkIw8Sf37jgSsfBYFoB22246yhcpyqpQIqb-ULWJPMV49oPpkKKHo2vPnFonQOII9ru6XA6B8QoA34LoMb_4BIifc0I-P8-RW8.gpZ5W92-G_1oqK6XN0rAFOjA3hBZa8of6GcMnoeZI_I&dib_tag=se&keywords=hunde%2Baufstehhilfe&qid=1770143977&sprefix=hunde%2Baufstehhilf%2Caps%2C164&sr=8-6&th=1',
    zooplusLink: '#',
  },
  {
    id: 'mobility-002',
    name: 'Antirutsch-Socken',
    image: 'https://readdy.ai/api/search-image?query=non%20slip%20dog%20socks%20with%20rubber%20grips%20for%20senior%20dogs%20product%20photography%20clean%20background%20showing%20grip%20pattern%20and%20comfortable%20design&width=400&height=400&seq=prod-mobility-002&orientation=squarish',
    reason: 'Antirutsch-Socken geben Halt auf glatten Böden und verhindern Ausrutschen, was besonders bei Hunden mit Gelenkproblemen wichtig ist.',
    suitableFor: ['Glatte Böden', 'Mehr Sicherheit', 'Gelenkschonung'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B0C5QYTXT3',
    zooplusLink: '#',
  },
  {
    id: 'mobility-003',
    name: 'Hunderampe',
    image: 'https://readdy.ai/api/search-image?query=foldable%20dog%20ramp%20for%20car%20and%20furniture%20with%20non%20slip%20surface%20product%20photography%20simple%20background%20showing%20sturdy%20construction&width=400&height=400&seq=prod-mobility-003&orientation=squarish',
    reason: 'Rampen ermöglichen es Ihrem Hund, ohne Springen ins Auto oder auf Möbel zu gelangen. Das schont die Gelenke erheblich.',
    suitableFor: ['Auto Ein- und Ausstieg', 'Sofa und Bett', 'Gelenkschonung'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: '#',
    zooplusLink: '#',
  },
];

// ============================================
// STABILITÄT & SICHERHEIT PRODUKTE
// ============================================
export const stabilityProducts: AffiliateProduct[] = [
  {
    id: 'stability-001',
    name: 'Antirutsch-Teppichläufer',
    image: 'https://readdy.ai/api/search-image?query=non%20slip%20carpet%20runner%20for%20dogs%20on%20hardwood%20floors%20product%20photography%20neutral%20background%20showing%20grip%20texture%20and%20quality%20material&width=400&height=400&seq=prod-stability-001&orientation=squarish',
    reason: 'Teppichläufer schaffen sichere Laufwege auf glatten Böden und geben älteren Hunden mehr Vertrauen beim Gehen.',
    suitableFor: ['Glatte Böden absichern', 'Sturzprävention', 'Mehr Selbstvertrauen'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B09JGHF8DC',
    zooplusLink: '#',
  },
  {
    id: 'stability-002',
    name: 'Stützgeschirr',
    image: 'https://readdy.ai/api/search-image?query=full%20body%20support%20harness%20for%20senior%20dogs%20with%20lifting%20handles%20product%20photography%20clean%20background%20showing%20supportive%20design&width=400&height=400&seq=prod-stability-002&orientation=squarish',
    reason: 'Ein Stützgeschirr gibt Ihnen die Möglichkeit, Ihren Hund bei Bedarf zu stabilisieren und zu unterstützen.',
    suitableFor: ['Ganzkörper-Unterstützung', 'Spaziergänge', 'Rehabilitation'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: '#',
    zooplusLink: '#',
  },
  {
    id: 'stability-003',
    name: 'Pfotenschutz mit Grip',
    image: 'https://readdy.ai/api/search-image?query=dog%20paw%20grip%20pad%20protector%20for%20senior%20dogs%20product%20photography%20simple%20background%20showing%20non%20slip%20rubber%20sole&width=400&height=400&seq=prod-stability-003&orientation=squarish',
    reason: 'Pfotenschutz mit Gummisohle gibt besseren Halt als normale Pfoten und schützt gleichzeitig empfindliche Ballen.',
    suitableFor: ['Besserer Halt', 'Pfotenschutz', 'Indoor und Outdoor'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: '#',
    zooplusLink: '#',
  },
];

// ============================================
// KOMFORT & LIEGEN PRODUKTE
// ============================================
export const comfortProducts: AffiliateProduct[] = [
  {
    id: 'comfort-001',
    name: 'Orthopädisches Hundebett',
    image: 'https://readdy.ai/api/search-image?query=orthopedic%20memory%20foam%20dog%20bed%20for%20senior%20dogs%20product%20photography%20neutral%20background%20showing%20supportive%20cushioning%20and%20comfortable%20design&width=400&height=400&seq=prod-comfort-001&orientation=squarish',
    reason: 'Memory-Foam-Betten passen sich dem Körper an und verteilen den Druck gleichmäßig. Das verhindert Druckstellen und entlastet schmerzende Gelenke.',
    suitableFor: ['Arthrose und Gelenkschmerzen', 'Druckstellen vermeiden', 'Erholsamer Schlaf'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B0BNLVX3CR',
    zooplusLink: '#',
  },
  {
    id: 'comfort-002',
    name: 'Erhöhte Futternäpfe',
    image: 'https://readdy.ai/api/search-image?query=elevated%20raised%20dog%20food%20bowl%20stand%20for%20senior%20dogs%20product%20photography%20simple%20background%20showing%20ergonomic%20height%20and%20stable%20design&width=400&height=400&seq=prod-comfort-002&orientation=squarish',
    reason: 'Erhöhte Näpfe reduzieren die Belastung von Nacken, Schultern und Rücken beim Fressen und Trinken. Das ist besonders wichtig bei Arthrose.',
    suitableFor: ['Nacken- und Rückenschmerzen', 'Arthrose', 'Bequemeres Fressen'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B0CSS34DXT',
    zooplusLink: '#',
  },
  {
    id: 'comfort-003',
    name: 'Rampen für Auto',
    image: 'https://readdy.ai/api/search-image?query=portable%20dog%20ramp%20for%20car%20with%20non%20slip%20surface%20product%20photography%20neutral%20background%20showing%20gentle%20incline%20and%20sturdy%20construction&width=400&height=400&seq=prod-comfort-003-v2&orientation=squarish',
    reason: 'Rampen ermöglichen es Ihrem Hund, ohne Springen ins Auto zu gelangen. Das schont die Gelenke und erhält die Mobilität.',
    suitableFor: ['Gelenkschonung', 'Vermeidung von Sprüngen', 'Selbstständigkeit erhalten'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/Hunderampe-Klappbar-Teleskop-Rampe-gro%C3%9Fe/dp/B0CS9V77X8/ref=sr_1_6?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=24UD6XHSK0M1H&dib=eyJ2IjoiMSJ9.RPPg-yTTaMfA525qdXk_a19ihmbVAP1I9P1WgZ5sQz-h_sYEpFGtn4qKu2FjsIHmcHhCMKSS_VMwMRhOsE13duYFCZt7tVAf_aack3w1LeBEbpKm4FTEUKECEDWieCGp5VeCqpW8wWjuQuUr2e5HgKT7mJNt1kktSD_2GGLzeYldB8wgzNSwRrA9hILjgYGi5wjp4ax_4OTwdbN0HxQMu00ItsAkAFoMCjLuVEr5zJe1tGOd9fkV7J_ux9AsCVFCxbLxpo3cCiLAe0zohQ4364llib24Acyg4YvtIQ8S1BE.zULL5EGe__s-OwQBFT5fT5eK7HdtNdDFE9qvin_WEuQ&dib_tag=se&keywords=rampe%2Bf%C3%BCr%2Bauto%2Bhund&qid=1770143666&sprefix=rampen%2Bf%C3%BCrs%2Bauto%2Bhun%2Caps%2C562&sr=8-6&th=1',
    zooplusLink: '#',
  },
  {
    id: 'comfort-004',
    name: 'Rampen für Sofa',
    image: 'https://readdy.ai/api/search-image?query=portable%20dog%20ramp%20for%20couch%20and%20furniture%20with%20non%20slip%20surface%20product%20photography%20neutral%20background%20showing%20gentle%20incline%20and%20sturdy%20construction%20for%20indoor%20use&width=400&height=400&seq=prod-comfort-004-v2&orientation=squarish',
    reason: 'Rampen ermöglichen es Ihrem Hund, ohne Springen auf das Sofa zu gelangen. Das schont die Gelenke erheblich.',
    suitableFor: ['Gelenkschonung', 'Vermeidung von Sprüngen', 'Selbstständigkeit erhalten'],
    // === IHRE AFFILIATE-LINKS HIER EINTRAGEN ===
    amazonLink: 'https://www.amazon.de/dp/B0F7R3R5N8',
    zooplusLink: '#',
  },
];

// ============================================
// NAHRUNGSERGÄNZUNG & GELENKUNTERSTÜTZUNG
// ============================================
export const supplementProducts: AffiliateProduct[] = [
  {
    id: 'supplement-001',
    name: 'Grünlippmuschel-Pulver',
    image: 'https://readdy.ai/api/search-image?query=green%20lipped%20mussel%20powder%20supplement%20for%20dogs%20in%20glass%20jar%20with%20wooden%20spoon%20natural%20joint%20support%20product%20photography%20clean%20white%20background%20showing%20fine%20powder%20texture&width=400&height=400&seq=prod-supplement-001&orientation=squarish',
    reason: 'Grünlippmuschel enthält natürliche Glykosaminoglykane und Omega-3-Fettsäuren, die Entzündungen hemmen und den Knorpelaufbau unterstützen können.',
    suitableFor: ['Gelenkunterstützung', 'Entzündungshemmend', 'Natürliche Quelle'],
    amazonLink: 'https://www.amazon.de/dp/B00GXPR7BO',
    zooplusLink: '#',
  },
  {
    id: 'supplement-002',
    name: 'Omega-3 Lachsöl',
    image: 'https://readdy.ai/api/search-image?query=salmon%20oil%20bottle%20for%20dogs%20omega%203%20supplement%20golden%20liquid%20in%20dark%20glass%20bottle%20with%20dropper%20product%20photography%20clean%20white%20background%20showing%20premium%20quality%20fish%20oil&width=400&height=400&seq=prod-supplement-002&orientation=squarish',
    reason: 'Omega-3-Fettsäuren aus Lachsöl wirken entzündungshemmend und können Gelenkschmerzen bei Arthrose lindern. Zusätzlich unterstützen sie Haut und Fell.',
    suitableFor: ['Entzündungshemmend', 'Gelenkgesundheit', 'Haut und Fell'],
    amazonLink: 'https://www.amazon.de/dp/B07WNPTMZZ',
    zooplusLink: '#',
  },
  {
    id: 'supplement-003',
    name: 'Glucosamin & Chondroitin Tabletten',
    image: 'https://readdy.ai/api/search-image?query=glucosamine%20chondroitin%20tablets%20for%20dogs%20joint%20supplement%20in%20white%20container%20with%20tablets%20visible%20product%20photography%20clean%20white%20background%20showing%20quality%20supplements&width=400&height=400&seq=prod-supplement-003&orientation=squarish',
    reason: 'Glucosamin und Chondroitin sind Bausteine des Knorpels. Als Ergänzung können sie den Knorpelabbau verlangsamen und die Gelenkschmierung verbessern.',
    suitableFor: ['Knorpelaufbau', 'Gelenkschmierung', 'Langzeitunterstützung'],
    amazonLink: 'https://www.amazon.de/dp/B003XNTTNG',
    zooplusLink: '#',
  },
  {
    id: 'supplement-004',
    name: 'MSM Pulver (Methylsulfonylmethan)',
    image: 'https://readdy.ai/api/search-image?query=MSM%20powder%20supplement%20for%20dogs%20in%20glass%20container%20organic%20sulfur%20joint%20support%20product%20photography%20clean%20white%20background%20showing%20fine%20white%20powder&width=400&height=400&seq=prod-supplement-004&orientation=squarish',
    reason: 'MSM ist eine natürliche Schwefelverbindung, die entzündungshemmend wirkt und die Bildung von Kollagen und Knorpelgewebe unterstützen kann.',
    suitableFor: ['Entzündungshemmend', 'Kollagenbildung', 'Schmerzlinderung'],
    amazonLink: 'https://www.amazon.de/dp/B01N9JGZQZ',
    zooplusLink: '#',
  },
];
